import axios from "axios";
import {createAxiosHelper} from "@/utils/httpUtils";
import {FeesRecommended, StatusPage, StatusPageHeartbeat, StatusPageHeartbeatResponse} from "@/utils/stateApiType";
import {BTC_FEE_API, FRACTAL_FEE_API, STATE_API,} from "@/utils/constants";

const customAxios = axios.create({
    baseURL: STATE_API,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
})


const axiosHelper = createAxiosHelper<{ code: number, msg: string, data: unknown }>(customAxios, (data) => {
    if (data.code === 1006) {
        return data.code
    }

    if (data.code !== 0) {
        throw new Error(`${data.msg}`)
    }

    return data.data;
});

const get = axiosHelper.get;
const post = axiosHelper.post;

export const stateApi = {
    getStatusPage(serviceName:string): Promise<StatusPage
    > {
        return get(`/status-page/${serviceName}`,)
    },
    getStatusPageHeartbeat(serviceName:string,limit=360,interval=1): Promise<StatusPageHeartbeat
    > {
        return get(`/status-page/heartbeat/${serviceName}?limit=${limit}&interval=${interval}`,)
    },
    async getStatusPageHeartbeatWithServerTime(serviceName:string,limit=360,interval=1): Promise<StatusPageHeartbeatResponse> {
        const response = await customAxios.get<StatusPageHeartbeat>(`/status-page/heartbeat/${serviceName}?limit=${limit}&interval=${interval}`)
        if (response.status !== 200) {
            throw new Error(String(response.status))
        }

        const dateHeader = response.headers.date
        const serverTime = dateHeader ? new Date(dateHeader) : null
        return {
            data: response.data,
            serverTime: serverTime && !Number.isNaN(serverTime.getTime()) ? serverTime : null,
        }
    },
    getFeesRecommendedFractal(): Promise<FeesRecommended
    > {
        return get(`${FRACTAL_FEE_API}/fees/recommended`,)
    },
    getFeesRecommendedBtc(): Promise<FeesRecommended
    > {
        return get(`${BTC_FEE_API}/v1/fees/recommended`,)
    },
}
